var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    [
      _c(
        "v-list-tile",
        { staticClass: "select-item--remove-padding" },
        [
          _vm.coIcon
            ? _c(
                "v-list-tile-avatar",
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v(_vm._s(_vm.coIcon))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list-tile-content",
            { attrs: { color: "primary" } },
            [
              _c("v-list-tile-title", {
                domProps: { innerHTML: _vm._s(_vm.coLabel) }
              }),
              _vm._v(" "),
              _c("v-list-tile-sub-title", {
                domProps: { innerHTML: _vm._s(_vm.coSubLabel) }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19279e15", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19279e15","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/multi-select/search-item/template.html
// module id = null
// module chunks = 